// extracted by mini-css-extract-plugin
module.exports = {"container":"container__2YNZK","list":"list__1XA9m","item":"item__1FQ95"};